export class EmployeeSummary {

    public roleCode?: string;
    public email?: string;
    public firstname: string;
    public lastname: string;
    public phone: string;


    constructor(roleCode: string, email: string, firstname: string, lastname: string, phone: string) {
        this.roleCode = roleCode;
        this.email = email;
        this.firstname = firstname;
        this.lastname = lastname;
        this.phone = phone;
    }
}
